import { makeStyles } from '@material-ui/core/styles';
import { COLORS, SPACING } from '../constants';

export const useStyles = makeStyles(() => ({
  root: {
    flex: 1,
    display: 'flex',
    overflow: 'hidden',
  },
  mainContent: {
    flex: 1,
    overflow: 'auto',
    padding: SPACING.sectionGap,
  },
  breadcrumbs: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    marginBottom: 8,
    fontSize: 11,
    color: COLORS.muted,
  },
  breadcrumbButton: {
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    padding: 0,
    font: 'inherit',
    fontSize: 'inherit',
  },
  breadcrumbActive: {
    color: COLORS.primary,
    fontWeight: 600,
  },
  breadcrumbInactive: {
    color: COLORS.muted,
    fontWeight: 400,
  },
  filterBar: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 16,
    justifyContent: 'flex-end',
    marginBottom: 16,
    padding: '8px 0',
    borderBottom: `1px solid ${COLORS.border}`,
  },
  locationHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 20,
  },
  locationActions: {
    display: 'flex',
    gap: 6,
  },
  emptyState: {
    padding: 20,
    textAlign: 'center',
    color: COLORS.muted,
    fontSize: 13,
    background: COLORS.white,
    borderRadius: 6,
    border: `1px dashed ${COLORS.border}`,
  },
  statusMessage: {
    marginBottom: 12,
    fontSize: 13,
  },
}));
